/* lg-slap-wrap-upsell - one-click add for the cart-drawer upsell rail.

   Loaded from snippets/cart-drawer.liquid, deliberately OUTSIDE #CartDrawer: that is the
   element whose innerHTML CartDrawer.renderContents() replaces on every cart update, and a
   <script> re-inserted via innerHTML never executes. Delegating from document and loading
   from outside the replaced subtree is what makes this survive.

   The markup is a real /cart/add form, so an add still works if this file fails to load.
   This only upgrades it to an in-drawer AJAX add, mirroring assets/product-form.js. */
(function () {
  if (window.lgCartUpsellAddBound) return;
  window.lgCartUpsellAddBound = true;

  document.addEventListener('submit', function (evt) {
    var form = evt.target && evt.target.closest ? evt.target.closest('form[data-lg-upsell-add]') : null;
    if (!form) return;
    evt.preventDefault();

    if (form.getAttribute('data-lg-busy') === 'true') return;
    form.setAttribute('data-lg-busy', 'true');

    var button = form.querySelector('button[type="submit"]');
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding...';
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) { return section.id; }).join(',')
      );
      body.append('sections_url', window.location.pathname);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || 'add failed');
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(state);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        /* Never leave a dead button: fall back to the native form post. */
        form.removeAttribute('data-lg-upsell-add');
        form.submit();
      });
  });
})();
